<template>
  <div class="my">
    <navigation />
    <router-view></router-view>
  </div>
</template>
<script>
import navigation from "@/components/common/navigation.vue";
export default {
  components: {
    navigation
  }
  // data () {
  //   return {
  //     isShowIndex: ''
  //   }
  // }
};
</script>
<style lang="scss">
.my {
  a,
  a:hover {
    color: #fff !important;
  }
}
.select {
  .ivu-select-selection {
    background: transparent;
    height: 40px !important;
    line-height: 40px !important;
  }
  .ivu-select-placeholder,
  .ivu-select-selected-value {
    height: 40px !important;
    line-height: 40px !important;
    color: #fff;
  }
}
.search {
  .ivu-input-wrapper {
    width: 95%;
  }
  .ivu-input {
    background: transparent;
    border-radius: 30px;
    height: 40px;
    color: #fff;
    padding-left: 18px;
  }
  .ivu-icon {
    background: linear-gradient(0, #09a3d8 0%, #09cec9 100%);
    color: #fff;
    border-radius: 50%;
    width: 42px;
    height: 42px;
    line-height: 42px;
    font-size: 28px;
    margin-top: -1px;
    margin-right: 0px;
  }
}
</style>
<style lang="scss" scoped>
.my {
  // background: url("../../assets/my/bg.jpg") center center no-repeat;
  // background-attachment: fixed;
  // background-size: 100% 100%;
  background: linear-gradient(
      180deg,
      rgba(111, 134, 214, 1) 7%,
      rgba(77, 188, 235, 1) 100%
    );
  margin-top: -80px;
  padding-top: 80px;
  // min-height: calc(100vh + 80px);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/myIndex.vue